import API, { APIError } from './api'

class BatchStore {

}

export default class BatchAPI extends API {

  constructor(client, opts, middlewares = []) {

    // we are not directly connecting the batch api to a specific store, but we
    // create a fake one. This is because items in a batch job may each belong
    // to their own stores
    super(new BatchStore(), client, opts, middlewares)

  }

  load() {

  }

  save(models: Array, opts: Object = {}) {

    const method = 'post'

    const jobs = models.map((model) => {

      if (!(model.store && model.store.api)) {
        console.log(model)
        throw new APIError('All models in a batch job need a `store` with a `api` propertly!')

      }

      const modelAPI = model.store.api

      const route = modelAPI.getRoute(model.id, opts).replace(/\/$/, '')

      let modelData = model.getJSON
        ? model.getJSON()
        : null

      if (!model.toJSON) {
        modelData = model.toJSON
          ? model.toJSON()
          : model
      }

      return {
        route,
        data: modelData
      }
    })

    const url = this.getURL()

    return this.createRequest(method)(url, {
      data: { jobs }
    })
      .then((results) => {

        results.forEach((result, i) => {
          if (result.statusCode === 200) {
            models[i].set(result.body)
          }
          else {
            console.error(`Batch API error: ${result.body.message}`)
          // TODO: define how to treat errors
          }
        })

        return models

      })

  }

  destroy() {

  }

}



// WEBPACK FOOTER //
// ./src/shared/api/batch-api.js